var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7805 16.5605C16.6945 16.5605 15.8105 17.4445 15.8105 18.5305C15.8105 19.6165 16.6945 20.4995 17.7805 20.4995C18.8675 20.4995 19.7515 19.6165 19.7515 18.5305C19.7515 17.4445 18.8675 16.5605 17.7805 16.5605Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21902 16.5605C4.13302 16.5605 3.24902 17.4445 3.24902 18.5305C3.24902 19.6165 4.13302 20.4995 5.21902 20.4995C6.30602 20.4995 7.19002 19.6165 7.19002 18.5305C7.19002 17.4445 6.30602 16.5605 5.21902 16.5605Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5003 16.5605C10.4143 16.5605 9.53027 17.4445 9.53027 18.5305C9.53027 19.6165 10.4143 20.4995 11.5003 20.4995C12.5873 20.4995 13.4713 19.6165 13.4713 18.5305C13.4713 17.4445 12.5873 16.5605 11.5003 16.5605Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7805 10.0303C16.6945 10.0303 15.8105 10.9143 15.8105 12.0003C15.8105 13.0863 16.6945 13.9693 17.7805 13.9693C18.8675 13.9693 19.7515 13.0863 19.7515 12.0003C19.7515 10.9143 18.8675 10.0303 17.7805 10.0303Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5003 10.0303C10.4143 10.0303 9.53027 10.9143 9.53027 12.0003C9.53027 13.0863 10.4143 13.9693 11.5003 13.9693C12.5873 13.9693 13.4713 13.0863 13.4713 12.0003C13.4713 10.9143 12.5873 10.0303 11.5003 10.0303Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21902 10.0303C4.13302 10.0303 3.24902 10.9143 3.24902 12.0003C3.24902 13.0863 4.13302 13.9693 5.21902 13.9693C6.30602 13.9693 7.19002 13.0863 7.19002 12.0003C7.19002 10.9143 6.30602 10.0303 5.21902 10.0303Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7805 7.43949C18.8675 7.43949 19.7515 6.55549 19.7515 5.46949C19.7515 4.38349 18.8675 3.50049 17.7805 3.50049C16.6945 3.50049 15.8105 4.38349 15.8105 5.46949C15.8105 6.55549 16.6945 7.43949 17.7805 7.43949Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5003 3.5C10.4143 3.5 9.53027 4.384 9.53027 5.47C9.53027 6.556 10.4143 7.439 11.5003 7.439C12.5873 7.439 13.4713 6.556 13.4713 5.47C13.4713 4.384 12.5873 3.5 11.5003 3.5Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21902 3.5C4.13302 3.5 3.24902 4.384 3.24902 5.47C3.24902 6.556 4.13302 7.439 5.21902 7.439C6.30602 7.439 7.19002 6.556 7.19002 5.47C7.19002 4.384 6.30602 3.5 5.21902 3.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/ID.7676b313bd86a9485df77645663ce963.svg";
export { ForwardRef as ReactComponent };